import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelpFile } from '~core/model';
import { StaticDataService } from '~core/services';
import { HelpFiles } from '~shared/utils/help-files';
import { ContactUsModalComponent } from './contact-us-modal.component';
import { LearnMoreModalComponent } from './learn-more-modal.component';

@Component({
  selector: 'idap-help-icon',
  templateUrl: './help-icon.component.html',
  styleUrls: ['./help-icon.component.scss']
})
export class HelpIconComponent implements OnInit {
  helpFiles: HelpFile[];
  constructor(private staticService: StaticDataService, private modalService: NgbModal) { }

  ngOnInit() {
    this.helpFiles = HelpFiles;
  }

  openContactDetails() {
    const modalRef = this.modalService.open(ContactUsModalComponent, {
      windowClass: 'modal-center'
    });
  }

  openLearnMore() {
    const modalRef = this.modalService.open(LearnMoreModalComponent, {
      windowClass: 'learn-more-modal modal-center'
    });
  }

  download(file: HelpFile) {
    this.staticService.downloadHelpFiles(file).take(1)
      .subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/help-icon.component.ts